import { AfterViewInit, Component, ElementRef, Inject, OnDestroy, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SnackbarService } from '../../core/services/snackbar.service';

@UntilDestroy()
@Component({
  selector: 'app-generate-clinic-registration-link',
  templateUrl: './generate-clinic-registration-link.component.html',
  styleUrls: ['./generate-clinic-registration-link.component.scss'],
})
export class GenerateClinicRegistrationLinkComponent implements OnInit, AfterViewInit {

  @ViewChild('qrcodeCanvasElement', { static: false }) qrcodeCanvas!: ElementRef<HTMLCanvasElement>;

  qrCodeDataUrl: string;
  clinicId: string;
  clinicName: string;
  clinicDate: number;


  constructor(
    private route: ActivatedRoute,
    @Inject(DOCUMENT) private document: Document,
    private snackbarService: SnackbarService,
  ) {}

  ngOnInit(): void {
    this.route.queryParamMap.pipe(untilDestroyed(this)).subscribe((params) => {
      this.clinicId = params.get('clinicId');
      this.clinicName = params.get('clinicName');
      try{
        this.clinicDate = Number(params.get('clinicDate'));
        if (isNaN(this.clinicDate) || this.clinicDate <= 0) {
          this.clinicDate = undefined;
        }
      }catch (e){}
      this.qrCodeDataUrl = undefined;
      if (this.clinicId && window?.location?.origin) {
        const host = window.location.origin;
        this.qrCodeDataUrl = `${host}/patient-registration/services?orgId=${this.clinicId}`;
      }
    });
  }

  ngAfterViewInit(): void {
    if (this.qrCodeDataUrl) {
      setTimeout(() => {
        this.initiateDownload();
      }, 200);
    }
  }

  initiateDownload() {
    const svgPromise:Promise<string> =  (this.qrcodeCanvas as any).toSVG();
    svgPromise.then((svg) => {
      const blob = new Blob([svg], { type: 'image/svg+xml' });
      const url = URL.createObjectURL(blob);

      const link = this.document.createElement('a');
      link.href = url;
      link.download = `qrcode_${this.clinicId || 'registration'}.svg`;

      this.document.body.appendChild(link);
      link.click();
      this.document.body.removeChild(link);

      URL.revokeObjectURL(url);
    })
  }

  copyLink() {
    if (this.qrCodeDataUrl) {
      this.snackbarService.notify('Link copied to clipboard');
    }
  }
}
